export default __webpack_public_path__ + "static/media/77-East-phase-02.87f4cf52.webp";